import { createClient } from "@supabase/supabase-js";


const supabaseUrl = process.env.REACT_APP_SUPABASE_URL ??'';
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ??'';

export const supabase_stories = createClient(supabaseUrl, supabaseKey,{
    db:{
        schema:'stories'
    }
});